// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

 .AddUser_headingContainer__uYYar {
    display: flex;
    justify-content: space-between;
  }
  
  .AddUser_closeButton__sMKKa {
    padding: 0.2rem;
    border: 1px #47C2BB solid;
    color: #47C2BB;
  }
  
  .AddUser_formItem__uGHDB {
    margin-top: 1rem;
  }
  
  .AddUser_formLabel__1yJ4D {
    font-weight: 600;
  }
  
  .AddUser_formInput__7RPQr {
    margin-top: 0.3rem;
  }
  
  .AddUser_validation__PDlH7 {
    color: red;
  }
  
  .AddUser_buttonContainer__aZbhW {
    margin-top: 2rem;
    margin-bottom: 1rem;
    display: flex;
    justify-content: center;
  }
  
  .AddUser_submitButton__16fMb {
    width: 10rem;
  }

  .AddUser_imageDev__HNX5w{
    display: flex;
    justify-content: center;
    margin-bottom: 20px; 
    margin-top: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/Components/User/AddUser.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;IACG,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;EAClB","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 31/3/2023\r\n */\r\n\r\n .headingContainer {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .closeButton {\r\n    padding: 0.2rem;\r\n    border: 1px #47C2BB solid;\r\n    color: #47C2BB;\r\n  }\r\n  \r\n  .formItem {\r\n    margin-top: 1rem;\r\n  }\r\n  \r\n  .formLabel {\r\n    font-weight: 600;\r\n  }\r\n  \r\n  .formInput {\r\n    margin-top: 0.3rem;\r\n  }\r\n  \r\n  .validation {\r\n    color: red;\r\n  }\r\n  \r\n  .buttonContainer {\r\n    margin-top: 2rem;\r\n    margin-bottom: 1rem;\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .submitButton {\r\n    width: 10rem;\r\n  }\r\n\r\n  .imageDev{\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 20px; \r\n    margin-top: 20px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `AddUser_headingContainer__uYYar`,
	"closeButton": `AddUser_closeButton__sMKKa`,
	"formItem": `AddUser_formItem__uGHDB`,
	"formLabel": `AddUser_formLabel__1yJ4D`,
	"formInput": `AddUser_formInput__7RPQr`,
	"validation": `AddUser_validation__PDlH7`,
	"buttonContainer": `AddUser_buttonContainer__aZbhW`,
	"submitButton": `AddUser_submitButton__16fMb`,
	"imageDev": `AddUser_imageDev__HNX5w`
};
export default ___CSS_LOADER_EXPORT___;
